import * as React from 'react';



export default class ExpandIcon extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
       <svg xmlns="http://www.w3.org/2000/svg" className={this.props.className}  width="16" height="16" viewBox="0 0 16 16">
            <g fill="none" fillRule="evenodd">
                <circle cx="8" cy="8" r="8" fill="#F6F8F9"/>
                <g stroke="#666">
                    <path d="M7.473 8.494L4.3 11.667M11.667 4.3L8.494 7.473M9.499 4.3h2.168v1.966M6.468 11.628H4.3V9.662"/>
                </g>
            </g>
        </svg>
    )
  }
}
